"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.LONG_TIMEOUT_VALUE = exports.SHORT_TIMEOUT_VALUE = exports.COMMENTS_NAMESPACES = exports.SENTIMENT_NAMESPACES = exports.SENTIMENT_TYPES = void 0;
exports.SENTIMENT_TYPES = {
    LIKE: ":like:",
};
exports.SENTIMENT_NAMESPACES = {
    COMMENTS: "comments",
};
exports.COMMENTS_NAMESPACES = {
    COMMENTS: "comments",
    PARTS: "parts",
    PARAGRAPHS: "paragraphs",
};
// TimeoutValue(milliseconds) to control the timeout error threshold
// For testing, can change to an arbitrarily small number (i.e. 1ms) to force requests to time out
exports.SHORT_TIMEOUT_VALUE = 5000;
exports.LONG_TIMEOUT_VALUE = 20000;
